export default
	props:
	 	# The form variables to be binded
		value: Object
		familyOrDepartmentUnformatted: String
		jobFamilyOptions: Array
		locations: Array
		jobTypes: Array
		hasFilters: Boolean
		clearFilters: Function

	# Sync external v-models
	data: ->
		locationState: @value.location
		jobTypeState: @value.jobType
		queryState: @value.query
		familyOrDepartmentState: @value.familyOrDepartment

		# Used to force focus state in a form select
		jobFamilyFocus: false

		# Used to force hover state in a form select
		jobFamilyHover: false

	computed:
		payload: ->
			location: @locationState
			jobType: @jobTypeState
			query: @queryState
			familyOrDepartment: @familyOrDepartmentState

		jobFamilyOptionsUnformatted: -> [@familyOrDepartmentUnformatted]


	watch:
		'value.location': (location) -> @locationState = location
		'value.jobType': (jobType) -> @jobTypeState = jobType
		'value.query': (query) -> @queryState = query
		'value.familyOrDepartment': (familyOrDepartment) -> @familyOrDepartmentState = familyOrDepartment
		locationState: -> @$emit 'input', @payload
		jobTypeState: -> @$emit 'input', @payload
		queryState: -> @$emit 'input', @payload
		familyOrDepartmentState: -> @$emit 'input', @payload

	methods:
	 	# handle job family focus state
		focusFamily: -> @jobFamilyFocus = true
		blurFamily: -> @jobFamilyFocus = false

		# handle job family hover state
		hoverFamily: ->	@jobFamilyHover = true
		leaveHoverFamily: -> @jobFamilyHover = false
